/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { user } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const USER_VERIFY_TOTP = 'user.totpVerify';

queryClient.setMutationDefaults(USER_VERIFY_TOTP, {
  mutationFn: user.totpVerify,
  onError: (error) => {
    handleError(error);
  },
});
